import { OVERVIEW_HIGHLIGHTS } from "./documentationOverviewContent";
import { SECTION_EYEBROW, SECTION_SPACING, SECTION_TITLE } from "./overviewTokens";

export function WhatIsSection() {
  const { icon: Icon, title, paragraphs } = OVERVIEW_HIGHLIGHTS;

  return (
    <section aria-labelledby="doc-what-is" className={SECTION_SPACING}>
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Icon className="h-5 w-5" />
        </div>
        <div>
          <p className={SECTION_EYEBROW}>Overview</p>
          <h2 id="doc-what-is" className={SECTION_TITLE}>
            {title}
          </h2>
          <div className="mt-3 space-y-3 text-slate-700 leading-relaxed max-w-3xl">
            {paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
